/* -------------------------------------
 Global Error Service
 - Helper methods used to show alerts, toasts and friendly error messages to user across the app.
-------------------------------------- */

// Angular services
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { AlertController, LoadingController, Loading, ToastController } from 'ionic-angular';

// Our services & pages
import * as IwcfModels from '../api/ecom/ecomApi';
import { LoggerService }  from './logger.service';

@Injectable()
export class GlobalErrorService {

    loading: Loading;

    constructor(
        public http: Http, 
        private alertCtrl: AlertController, 
        private loadingCtrl: LoadingController,
        private log: LoggerService,
        private toastCtrl: ToastController) {}

    public presentToast(text){
        let toast = this.toastCtrl.create({
            message: text,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }
    
}



// WEBPACK FOOTER //
// ./src/shared/global-error.service.ts